import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  addCourierPairRateApi,
  deleteCourierPairRateApi,
  getCourierCarriersApi,
  getCourierLookupApi,
  getCourierPairRatesApi,
  updateCourierCarrierApi,
  updateCourierPairRateApi,
} from "../../../services/setting/courierServiceCostService";

const notify = (message) => toast.success(message, { position: toast.POSITION.TOP_RIGHT });

export const getCourierCarriers = createAsyncThunk("partner/getCourierCarriers", async (filters) => {
  const response = await getCourierCarriersApi(filters);
  return response.response;
});

export const updateCourierCarrier = createAsyncThunk("partner/updateCourierCarrier", async (data) => {
  const response = await updateCourierCarrierApi(data, data.id);
  notify("Update Carrier Rates successfully");
  return response.response;
});

// resource: "shipping-rates" | "partner-return-rates"
export const getCourierPairRates = createAsyncThunk("partner/getCourierPairRates", async ({ resource, filters }) => {
  const response = await getCourierPairRatesApi(resource, filters);
  return response.response;
});

export const addCourierPairRate = createAsyncThunk("partner/addCourierPairRate", async ({ resource, data }) => {
  const response = await addCourierPairRateApi(resource, data);
  notify("Add Rate successfully");
  return response.response;
});

export const updateCourierPairRate = createAsyncThunk("partner/updateCourierPairRate", async ({ resource, deliveryPartnerId, secondId, data }) => {
  const response = await updateCourierPairRateApi(resource, deliveryPartnerId, secondId, data);
  notify("Update Rate successfully");
  return response.response;
});

export const deleteCourierPairRate = createAsyncThunk("partner/deleteCourierPairRate", async ({ resource, deliveryPartnerId, secondId }) => {
  const response = await deleteCourierPairRateApi(resource, deliveryPartnerId, secondId);
  notify("Deleted Rate successfully");
  return response.response;
});

// name: "shippings" | "partners"
export const getCourierLookup = createAsyncThunk("partner/getCourierLookup", async (name) => {
  const response = await getCourierLookupApi(name);
  return { name, items: response.response };
});

const closedDialog = { type: "edit", props: { isOpen: false }, data: null };

const courierRateSlice = createSlice({
  name: "courierRate",
  initialState: {
    carriers: [],
    pairRates: {},
    lookups: { shippings: [], partners: [] },
    // One dialog per tab, keyed "carriers" / "shipping-rates" / "partner-return-rates".
    dialogs: {},
  },
  reducers: {
    openRateNewDialog: (state, action) => {
      state.dialogs[action.payload] = { type: "new", props: { isOpen: true }, data: null };
    },
    openRateEditDialog: (state, action) => {
      state.dialogs[action.payload.key] = { type: "edit", props: { isOpen: true }, data: action.payload.data };
    },
    closeRateDialog: (state, action) => {
      state.dialogs[action.payload] = closedDialog;
    },
  },
  extraReducers: {
    [getCourierCarriers.fulfilled]: (state, action) => {
      state.carriers = action.payload;
    },
    [getCourierPairRates.fulfilled]: (state, action) => {
      state.pairRates[action.meta.arg.resource] = action.payload;
    },
    [getCourierLookup.fulfilled]: (state, action) => {
      state.lookups[action.payload.name] = action.payload.items;
    },
  },
});

export const selectRateDialog = (key) => ({ partner }) => partner.courierRate.dialogs[key] || closedDialog;

export const { openRateNewDialog, openRateEditDialog, closeRateDialog } = courierRateSlice.actions;

export default courierRateSlice.reducer;
